import { ApiProperty } from "@nestjs/swagger";

export class POItemIdRequest{
    @ApiProperty()
    poItemId:number;
}